export function setPush(_push) {
  window.pushTo = _push;
}

// export function getPush() {
//   return window.pushTo;
// }
